import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: 'login'
        },
        {
            path: '/login',
            name: 'Login',
            component: require('../components/Login').default
        },
        {
            path: '/tutorial',
            name: 'Tutorial',
            component: require('../components/Tutorial').default
        },
        {
            path: '/game',
            name: 'Game',
            component: require('../components/Game').default
        },
        {
            path: '/result',
            name: 'Result',
            component: require('../components/Result').default
        },
        {
            path: '/lab',
            name: 'Lab',
            component: require('../components/Lab').default
        },
        {
            path: '/sheet',
            name: 'Sheet',
            component: require('../components/Sheet').default
        },
        {
            path: '/calc',
            name: 'Calc',
            component: require('../components/Calc').default
        },
    ]
})
